import { Component, Input } from '@angular/core';
import { AdsTxtStatus, AdsTxtStatusLabels } from '../../domain/adstxt-status.model';
import { Domain } from '../../domain/domain.model';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AdStatsDomainsService } from '../../services/ad-stats-domains.service';
import { GlobalSpinnerService } from '../loader-service/global-spinner.service';
import { AdstxtDiffDialogComponent } from './adstxt-diff-dialog.component';

@Component({
  selector: 'cm-adstxt-status-details',
  template: `
    <span class="text-center">
        <i class="fas fa-times text-danger" *ngIf="domain.adstxtStatus==AdsTxtStatus.NOT_EXIST" matTooltip="File does not exist"></i>
      </span>
    <span *ngIf="domain.adsTxtMissingRecords && domain.adstxtStatus!==AdsTxtStatus.NOT_EXIST">
      <span class="text-danger">Missing {{domain.adsTxtMissingRecords}}</span>
      <span class="link ml-2" (click)="openMissingAdstxt()">
        <i class="far fa-file-alt"></i>
      </span>
    </span>
    <span *ngIf="!domain.adsTxtMissingRecords && domain.adstxtStatus === AdsTxtStatus.VALID" class="text-success">Completed</span>
    <span *ngIf="!domain.adsTxtMissingRecords && domain.adstxtStatus === AdsTxtStatus.INCOMPLETE" class="text-danger link"
          (click)="openMissingAdstxt()">Incomplete</span>
  `,
  host: {'class': 'w-100'}
})
export class AdstxtStatusDetailsComponent {

  @Input()
  domain: Domain;

  @Input()
  pubDash: boolean;

  AdsTxtStatus = AdsTxtStatus;
  AdsTxtStatusLabels = AdsTxtStatusLabels;

  constructor(private domainsService: AdStatsDomainsService,
              private gss: GlobalSpinnerService,
              private matDialog: MatDialog) {
  }

  openMissingAdstxt() {
    if (this.pubDash) {
      this.matDialog.open(AdstxtDiffDialogComponent, <MatDialogConfig>{
        width: '600px',
        data: {
          domain: this.domain
        }
      });
    } else {
      this.domainsService.domainsAdstxtDiff(this.domain).subscribe(next => {
        this.gss.hideLoader();
        this.matDialog.open(AdstxtDiffDialogComponent, <MatDialogConfig>{
          data: {
            domain: this.domain,
            result: next,
          }
        });
      }, () => {
        this.gss.hideLoader();
      });
    }
  }
}
